import React from 'react'

function SectionBreak() {
  return (
    <div className='h-[50px] md:h-[100px]'>
           
    </div>
  )
}

export default SectionBreak